import { onCleanup } from './cleanup.js'

function hoverActive(deviceData) {
  const hoverActive = document.querySelectorAll('.hover-active')

  if(deviceData.isDesktop != true) return;

  hoverActive.forEach(item => {
    const onOver = () => item.classList.add('active')
    const onOut = () => hoverActive.forEach(el => el.classList.remove('active'))

    item.addEventListener('mouseover', onOver)
    item.addEventListener('mouseout', onOut)

    onCleanup(() => {
      item.removeEventListener('mouseover', onOver)
      item.removeEventListener('mouseout', onOut)
    })
  })
}

export default hoverActive
